import React, {
  Dispatch, SetStateAction, useEffect, useState,
} from 'react'
import { Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import LoadingSpinner from 'components/LoadingSpinner'
import FormRow from 'components/FormRow'

interface ProfileModalParams {
  isProfileModalVisible: boolean
  setIsProfileModalVisible: Dispatch<SetStateAction<boolean>>
  saveCustomerProfile: (accessCode: string) => Promise<void>
  nctsProfileAccessCode: Readonly<string>
}

function CustomerProfileModal({
  isProfileModalVisible,
  setIsProfileModalVisible,
  saveCustomerProfile,
  nctsProfileAccessCode,
}: Readonly<ProfileModalParams>) {
  const { t } = useTranslation()

  const [loading, setLoading] = useState(false)
  const [accessCode, setAccessCode] = useState<string>(nctsProfileAccessCode)

  useEffect(() => {
    setAccessCode(nctsProfileAccessCode)
  }, [nctsProfileAccessCode, isProfileModalVisible])

  return (
    <Modal
      show={isProfileModalVisible}
      className="overflow-hidden"
      dialogClassName="customs-modal modal"
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      onHide={() => {
        setIsProfileModalVisible(false)
      }}
      animation={false}
      centered
    >
      <Modal.Header>
        <Modal.Title>
          <h2 className="text-capitalize">
            {t('customsProfile.shareProfile')}
          </h2>
          <button
            type="button"
            className="btn btn-link no-underline btn-lg d-flex justify-content-center align-items-center px-0"
            onClick={() => {
              setIsProfileModalVisible(false)
            }}
          >
            <span>{t('buttons.close')}</span>
            <i className="fal fa-times fa-2x ms-2" />
          </button>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FormRow title={t('customers.accessCode', { context: 'capitalized' })}>
          <input
            className="form-control"
            type="text"
            maxLength={4}
            placeholder={t('common.fieldPlaceholder')}
            value={accessCode}
            onChange={(event) => {
              setAccessCode(event.target.value)
            }}
          />
        </FormRow>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-dark btn-lg m-0 text-primary"
          onClick={() => {
            saveCustomerProfile(accessCode ?? '').finally(() => {
              setLoading(false)
              setIsProfileModalVisible(false)
            })
          }}
        >
          {
            loading && <LoadingSpinner />
          }
          {
            !loading && (
              <span>{t('buttons.save')}</span>
            )
          }
        </button>
      </Modal.Footer>
    </Modal>
  )
}

export default CustomerProfileModal
